import {commonFunctions} from 'common-types'

export type FunctionLibrary = commonFunctions

const name = 'ResponsiveComponentsExtensions'
const functionLibrary = {
    getIdOfFixedPositionWrapper: compId => `${compId}-pinned-layer`
}

export {name, functionLibrary}
